import { render, staticRenderFns } from "./card-producto-pedido-ver.vue?vue&type=template&id=26db0d12&scoped=true&"
import script from "./card-producto-pedido-ver.vue?vue&type=script&lang=js&"
export * from "./card-producto-pedido-ver.vue?vue&type=script&lang=js&"
import style0 from "./card-producto-pedido-ver.vue?vue&type=style&index=0&id=26db0d12&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26db0d12",
  null
  
)

export default component.exports